import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Grid, Modal, Button, Fade, Box, Hidden } from "@mui/material";
import { Close } from "@mui/icons-material";
import StrapiGridItemDanger from "./StrapiGridItemDanger";

export default function BioModal({ ExpandedText, buttonStyle, ...props }) {
  const [open, setOpen] = useState(false);
  const [bio, setBio] = useState();
  useEffect(() => {
    setBio(ExpandedText);
  }, [ExpandedText]);

  useEffect(() => {}, []);
  const handleOpen = () => {
    setOpen(() => {
      return true;
    });
  };

  const handleClose = e => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  };

  if (!ExpandedText) {
    return <Box sx={{ height: 36, m: "1rem 0 2rem" }} />;
  }
  const handleScrollDown = () => {
    document.getElementById("biography")?.scrollTo({ left: 0, top: 5000, behavior: "smooth" });
  };
  return (
    <>
      <Button
        onClick={handleOpen}
        variant="contained"
        fullWidth={true}
        sx={{ m: "1rem 0 2rem", ...buttonStyle }}
      >
        Bio
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        // onTransitionEnter={() => console.log(document.getElementById("biography"))}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Wrapper
            container
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            height={"100%"}
            width={"100%"}

            //   m={"0 auto"}
            //   p={8}
          >
            <Hidden smDown>
              <Close
                fontSize="large"
                onClick={handleClose}
                sx={{
                  backgroundColor: { md: "white" },
                  padding: { md: "1rem" },
                  position: "absolute",
                  right: { xs: 30, sm: "2svw" },
                  top: { xs: 30, sm: "calc(5dvh / 2)" },
                  zIndex: 99,
                }}
              />
            </Hidden>
            <Box
              position={"relative"}
              maxWidth={900}
              maxHeight={{ sm: "95dvh" }}
              overflow={"scroll"}
            >
              <Hidden smUp>
                <Close
                  fontSize="large"
                  onClick={handleClose}
                  sx={{
                    backgroundColor: { md: "white" },
                    padding: { md: "1rem" },
                    position: "absolute",
                    right: { xs: 30, sm: "2svw" },
                    top: { xs: 30, sm: "calc(5dvh / 2)" },
                    zIndex: 99,
                  }}
                />
              </Hidden>
              <Hidden smUp>
                <Button
                  onClick={handleScrollDown}
                  fullWidth
                  variant="contained"
                  sx={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 99,
                    height: 60,
                  }}
                >
                  Scroll Down
                </Button>
                {/* <Zoom in={trigger}>
                  <Box
                    width={"100%"}
                    bgcolor={props.theme.palette.primary.main}
                    sx={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 99,
                      height: 60,
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ArrowDropDownCircleSharp
                      sx={{ color: "white" }}
                      fontSize="large"
                      onClick={handleScrollDown}
                    />
                    Scroll Down
                  </Box>
                </Zoom> */}
              </Hidden>
              <StrapiGridItemDanger
                id="biography"
                onClick={handleClose}
                textBlockStyle={{
                  bgcolor: "rgba(255,255,255,.96)",
                  p: { xs: 2, sm: 8, md: 8 },
                  pt: { xs: 8 },
                  pb: { xs: 8 },
                  overflow: "scroll",
                  // width: { xs: "100svw", sm: "90svw", md: "90svw" },
                  height: { xs: "100dvh", sm: "90dvh", md: "fit-content" },
                }}
                Copy={bio}
              />
            </Box>
          </Wrapper>
        </Fade>
      </Modal>
    </>
  );
}
const Wrapper = styled(Grid)`
  p {
    font-size: 1rem;
    line-height: 1.7rem;
    ${props => props.theme.breakpoints.up("sm")} {
      line-height: 2rem;
    }
  }
  #biography > h3 {
    font-size: 1.25rem;
    padding-top: 0 !important;
    line-height: normal;
    ${props => props.theme.breakpoints.up("")} {
      font-size: 2.1875rem;
    }
  }
`;
